import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

export function buildPollingStatusConfig(pollingId: string, userUuid?: string): ApiCallConfig {
  return {
    method: HTTP_METHODS.GET,
    endpoint: INTERNAL_API_ENDPOINTS.POLLING_STATUS,
    queryParams: {
      pollingId,
      user_uuid: userUuid,
    },
  };
}
